import axiosClient from "../../../shared/lib/http/axiosClient";
import { RegisterModel } from "@models/register";
import { User } from "@models/user";

const ensureCsrfCookie = async (): Promise<void> => {
  await axiosClient.get("/sanctum/csrf-cookie");
};

export const login = async (email: string, password: string): Promise<User> => {
  await ensureCsrfCookie();

  const response = await axiosClient.post("/login", {
    email,
    password,
  });

  return response.data.user;
};

export const getUser = async (): Promise<User> => {
  const response = await axiosClient.get("/api/user");
  return response.data;
};

export const register = async (registerInfo: RegisterModel): Promise<User> => {
  await ensureCsrfCookie();

  const response = await axiosClient.post("/register", registerInfo);

  return response.data.user;
};

export const logout = async (): Promise<void> => {
  await ensureCsrfCookie();
  await axiosClient.post("/logout");
};
